/**
 * Where the backend lives, in one place.
 *
 * This used to be a `const apiUrl = "https://clickapp.win"` repeated in eight files, which is why
 * moving hosts was an eight-file change rather than a one-line one.
 *
 * The move itself: `clickapp.win` is now served by a Cloudflare Worker, which answers on the
 * apex hostname before anything reaches nginx. Requests to `clickapp.win/api/...` come back as the
 * Worker's HTML page with a 200 status — so `fetch` succeeds, `response.ok` is true, and the JSON
 * parse is what fails. The API is reached at `api.clickapp.win`, which proxies to the Spring app.
 *
 * Note this does NOT cover the photo URLs in `src/data/fallback/*.json`, which are absolute
 * `clickapp.win/uploads/...` links and are broken for the same reason. Those need a host that maps
 * to /var/www/uploads before they can be repointed.
 */
export const API_URL = "https://api.clickapp.win";
